<mat-form-field fxFlex>
	<input type="text" [placeholder]="placeholder" aria-label="Number" matInput [matAutocomplete]="auto"
		[(ngModel)]="AutoValue" (ngModelChange)="this.autoUpdate.next($event)" (keyup.enter)="enter()">
	<mat-autocomplete #auto="matAutocomplete" (optionSelected)="valueChanged()" [displayWith]="displayFn">
		<mat-option *ngFor="let option of options | async" [value]="option">
			{{option.customer}}
		</mat-option>
	</mat-autocomplete>
	<mat-icon color="primary" matSuffix (click)="addNewCustomer($event)" class="btn">add_circle</mat-icon>
</mat-form-field>